module.exports = __webpack_public_path__ + "static/img/background.eaefbea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article_2/portrait/background.jpg
// module id = rjmg
// module chunks = 1